import React, { useState } from "react";
import "./AppLayout.css";
import Sidebar, { NavigationPage } from "./Sidebar";

interface AppLayoutProps {
  children: React.ReactNode;
  currentPage: NavigationPage;
  onNavigate: (page: NavigationPage) => void;
}

const MenuIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 12H21M3 6H21M3 18H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const AppLayout: React.FC<AppLayoutProps> = ({ children, currentPage, onNavigate }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="app-layout">
      {/* Mobile Header */}
      <header className="app-layout__mobile-header">
        <button
          className="app-layout__menu-btn"
          onClick={() => setIsMobileMenuOpen(true)}
          aria-label="Open menu"
        >
          <MenuIcon />
        </button>
        <img src="/magnus.png" alt="MAGNUS" className="app-layout__mobile-logo" />
      </header>

      {/* Sidebar */}
      <Sidebar
        currentPage={currentPage}
        onNavigate={onNavigate}
        isMobileMenuOpen={isMobileMenuOpen}
        onCloseMobileMenu={() => setIsMobileMenuOpen(false)}
      />

      {/* Main Content Container */}
      <main className="app-layout__main">
        <div className="app-layout__content">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AppLayout;
